import * as yup from 'yup';
import type { Schema } from 'yup';
import { asFile, isImageAsset, type File, dataURItoBlob } from './fs';

declare module 'yup' {
  export interface StringSchema extends Schema {
    password: () => this; // <-- changing the return to `this` resolved the type error
  }
}

yup.addMethod(yup.string, 'password', function password() {
  return this.min(8).max(255);
});

function appendImageAsset(form: FormData, key: string, value: unknown): void {
  const valueRecord = value as Record<string, unknown> | undefined;
  const valueFile = valueRecord?.file ?? (valueRecord?.assets as Record<string, unknown>[] | undefined)?.[0]?.file;
  if (value instanceof File) {
    form.append(key, value, value.name);
    return;
  } else if (valueFile instanceof File) {
    form.append(key, valueFile, valueFile.name);
    return;
  }
  const formattedValue = isImageAsset(value)
    ? asFile(value)
    : typeof value !== 'string'
      ? JSON.stringify(value)
      : value;

  if (isImageAsset(value) && (formattedValue as unknown as File).uri.startsWith('data:')) {
    const file = formattedValue as unknown as File;
    form.append(key, dataURItoBlob(file.uri), file.name);
  } else {
    form.append(key, formattedValue as string);
  }
}

export function asFormData(record: object): FormData {
  const form = new FormData();

  Object.entries(record).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      if (Array.isArray(value) && value.length > 0 && value.some(isImageAsset)) {
        for (const item of value) {
          if (isImageAsset(item)) appendImageAsset(form, key, item);
        }
        return;
      }
      appendImageAsset(form, key, value);
    }
  });

  return form;
}
